import _ from 'lodash'
import { CATEGORIES } from '../constants'

const atelier = (data) => {
	const ateliers = data.map(
		({
			id,
			title: { rendered: title },
			content: { rendered: content },
			_embedded: embedded,
			slug,
			categories,
			acf: { lien },
		}) => {
			const catId = categories[0].toString()
			const category = catId && _.find(CATEGORIES.ATELIER, ({ id }) => catId === id)
			const imageSrc = embedded['wp:featuredmedia'][0]?.media_details?.sizes?.large?.source_url

			return {
				id,
				slug,
				title,
				content,
				category: (category && category.label) || null,
				categoryName: (category && category.name) || null,
				catId,
				lien,
				imageSrc,
			}
		},
	)

	return ateliers.reverse()
}

export default atelier
